import { useState, useEffect } from 'react'

import { gql, useQuery } from '@apollo/client';
import { THREE_MINUTES } from './pollIntervals';

const VERSION_QUERY = gql`
query ($nodes: [String!]!) {
  serviceGroup_node(where: { node: { name: { _in: $nodes } } }) {
    cb_versions: chef(path: "cookbook_deployment_data")
    node {
      name
    }
  }
}
`


const versionLookup = (lookupData, nodeName, appName) => {
    return lookupData[nodeName]?.[appName] || {
        "version": "-",
        "installed_epoch": "-",
        "installed": "-"
    };
};

export const getLatestVersion = (lookupData, nodeName, appNames) => {
    for (const appName of appNames) {
        const { version } = versionLookup(lookupData, nodeName, appName);
        if (version !== "-") {
            return version;
        }
    }
    return "-"; // Default return if no valid version found
};

export const getLatestDeployed = (lookupData, nodeName, appNames) => {
    for (const appName of appNames) {
        const { installed } = versionLookup(lookupData, nodeName, appName);
        if (installed !== "-") {
            return installed;
        }
    }
    return "-"; // Default return if no valid installed found
};

export const useVersionHistory = (nodes = []) => {
    const [lookupData, setLookupData] = useState({})
    const { data, loading } = useQuery(
        VERSION_QUERY,
        {
            variables: {
                nodes: [...new Set(nodes)]
            },
            pollInterval: THREE_MINUTES
        }
    )

    useEffect(() => {
        if (!loading && data) {
            let tmpData = {}
            data.serviceGroup_node.forEach(row => {
                let nodeName = row.node.name
                if (!tmpData[nodeName]) {
                    tmpData[nodeName] = {}
                }
                tmpData[nodeName] = row.cb_versions
            })
            setLookupData(tmpData)
        }
    }, [data, loading])

    return lookupData
}
